module.exports = __webpack_public_path__ + "static/img/Ocean.ecc8a68.png";


//////////////////
// WEBPACK FOOTER
// ./static/banners/Ocean.png
// module id = 2242
// module chunks = 61